import { gql } from "@apollo/client";

const GET_CHAPTER_DETAILS = gql`
  query ChapterDetails($id: ID!) {
    chapterDetails(id: $id) {
      chapter {
        id
        name
        level {
          title
        }
      }
      languageId
      cities {
        id
        name
      }
    }
  }
`;

export default GET_CHAPTER_DETAILS;
